<atx-modal-header class="border-0" (dismiss)="close()"> </atx-modal-header>

<atx-modal-body class="pl-4 pt-2">
  @if (loading$ | async) {
  <div class="d-flex w-100 p-2 justify-content-center align-items-center">
    <fa-icon [icon]="['fas', 'spinner']" [spin]="true" [pulse]="true"></fa-icon>
  </div>
  } @else {
  <div
    [innerHTML]="content$ | async | safeHtml"
    class="support-modal-content"
  ></div>
  }
</atx-modal-body>
